module.exports = __webpack_public_path__ + "static/media/IMG_6035-min.d99705a2.JPG";